import React from 'react';
import styled from 'styled-components';
import ToolTip from 'components/Tooltip';

export const TrackShortNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const InputLabelTooltip = ({ label, info }) => {
  return (
    <TrackShortNameWrapper>
      <span>{label}</span>
      <ToolTip title={label} info={true} content={info} />
    </TrackShortNameWrapper>
  );
};
